import { createElement, registerCustomElement } from "../../UI.ElementarControls/Utils/CustomElementUtils";
import { IAction } from "../Actions/IAction";
import { DropDownMenuItem } from "./DropDownMenuItem";
/**
     * Vyrenderuje položku DropDown jako button
     */
export class DropDownMenuItemButton extends DropDownMenuItem {
    public static createDropMenuItemButton(icon: string, action: IAction, locKey: string, enabled: boolean = false, priority: number = 15): DropDownMenuItem {
        const element = new DropDownMenuItemButton();
        element._init(element, icon, action, locKey, enabled, priority);
        return element;
    }

    protected override _createElement(): void {
        const container = createElement({ type: "button", classes: "dropdown-menu-button" }) as HTMLButtonElement;

        this._textElement = document.createElement("div");

        this.classList.add("DropDownMenuItem");
        this.classList.add("button-item");
        if (this.action) {
            this.classList.toggle("disabled", !this.action.isActive);
        }

        this._textElement.classList.add("Text");

        this._createIconElement();
        this._createCaptionElement();

        container.appendChild(this._iconElement);
        container.appendChild(this._textElement);
        this._textElement.appendChild(this._captionElement);
        this.appendChild(container);
    }

    public override focus(): void {
        if (this.firstElementChild instanceof HTMLElement) {
            this.firstElementChild.focus();
        }
    }
}

registerCustomElement("tsc-DropDownMenuItemButton", DropDownMenuItemButton);
